/** Public Synmora / JobMockAI contact inboxes */
export const SUPPORT_EMAIL = 'support@synmoraai.com';
export const INFO_EMAIL = 'info@synmoraai.com';
export const PRIVACY_EMAIL = 'privacy@synmoraai.com';
export const BILLING_EMAIL = 'billing@synmoraai.com';

/** Terms / legal inquiries (no separate legal@ mailbox yet) */
export const LEGAL_EMAIL = INFO_EMAIL;

export const CATEGORY_EMAIL = {
  'General Inquiry': INFO_EMAIL,
  'Technical Support': SUPPORT_EMAIL,
  'Billing & Subscriptions': BILLING_EMAIL,
  'Feature Request': SUPPORT_EMAIL,
  'Bug Report': SUPPORT_EMAIL,
  Partnership: INFO_EMAIL,
  'Media Inquiry': INFO_EMAIL,
  Other: INFO_EMAIL,
};

export function mailtoHref(email, { subject, body } = {}) {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const qs = params.toString();
  return `mailto:${email}${qs ? `?${qs}` : ''}`;
}

export function emailForCategory(category) {
  return CATEGORY_EMAIL[category] || INFO_EMAIL;
}

export function formatContactMailBody({ name, email, message }) {
  return [`Name: ${name}`, `Reply-to: ${email}`, '', message].join('\n');
}

export function buildContactMailto({ category, name, email, subject, message }) {
  const to = emailForCategory(category);
  const resolvedSubject = subject || `JobMockAI — ${category}`;
  const body = formatContactMailBody({ name, email, message });
  return {
    to,
    subject: resolvedSubject,
    body,
    href: mailtoHref(to, { subject: resolvedSubject, body }),
  };
}

export function formatContactClipboardText({ to, subject, body }) {
  return [`To: ${to}`, `Subject: ${subject}`, '', body].join('\n');
}

export default {
  SUPPORT_EMAIL,
  INFO_EMAIL,
  PRIVACY_EMAIL,
  BILLING_EMAIL,
  LEGAL_EMAIL,
  CATEGORY_EMAIL,
  mailtoHref,
  emailForCategory,
  formatContactMailBody,
  buildContactMailto,
  formatContactClipboardText,
};
